import { bluePalette, goodPalette, extendedGoodPalette, badPalette, reversedGoodPalette, reversedBadPalette, strongSupport, weakSupport, weakOppose, strongOppose, neutral } from "../../../../src/utils/pulsePalette.js";
import direction from "../../../../src/images/icons/direction.svg";
import { H1, H3 } from "../../../../src/components/layout/headings";
import * as React from 'react';
export default {
  bluePalette,
  goodPalette,
  extendedGoodPalette,
  badPalette,
  reversedGoodPalette,
  reversedBadPalette,
  strongSupport,
  weakSupport,
  weakOppose,
  strongOppose,
  neutral,
  direction,
  H1,
  H3,
  React
};